// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PaymentElementDemo: MarkdocTagRegistration = {
  tag: 'payment-element-demo',
  component: 'PaymentElementDemo',
  description: 'Display a interactive Payment Element demo',
};
